import { useRef } from "react";
import { usePiegeFocus } from "./guide/usePiegeFocus.js";
import { ContenuCredits } from "./info/ContenuCredits.js";
import { IconeFermer } from "./info/icones.js";
import { useInfos } from "./info/useInfos.js";
import * as i from "./info/infosStyles.js";
import * as s from "./splashStyles.js";
import "./info/infos.css";

/**
 * ============================================================================
 *  Credits.tsx — Les crédits, depuis l'écran d'accueil
 * ----------------------------------------------------------------------------
 *  La même fenêtre que celle de la visite (`info/CreditsPanel`) : le contenu est
 *  `ContenuCredits`, partagé — logo de l'Atelier, lignes de crédits, signature, bouton
 *  lien. Seule la coque diffère : à l'accueil il n'y a ni voix à mettre en pause ni menu
 *  d'informations, donc pas d'état partagé (`etatInfos`) ; le panneau se ferme par ×,
 *  par un clic sur le voile ou par Échap (voir `SplashScreen`).
 *
 *  Dialogue modal : focus piégé sur le panneau, puis rendu à l'item « Crédits » du menu.
 * ==========================================================================*/

export function Credits({ assetBaseUrl, onClose }: { assetBaseUrl: string; onClose(): void }) {
  const { t } = useInfos();
  const racine = useRef<HTMLDivElement>(null);
  const fermer = useRef<HTMLButtonElement>(null);

  usePiegeFocus(
    racine,
    true,
    () => fermer.current,
    () => null,
  );

  return (
    <div className="inf-voile" style={s.creditsFond} onClick={onClose}>
      <div
        ref={racine}
        role="dialog"
        aria-modal="true"
        aria-label={t("infoCredits")}
        className="inf-credits-fenetre"
        // Un clic dans la fenêtre ne doit pas atteindre le voile, qui ferme.
        onClick={(event) => event.stopPropagation()}
        style={i.creditsFenetre}
      >
        <button ref={fermer} type="button" className="inf-croix" aria-label={t("infoFermer")} onClick={onClose} style={i.croixFenetre}>
          <IconeFermer />
        </button>
        {/* À l'accueil, le lien s'ouvre sans rien à suspendre : aucune voix ne joue encore. */}
        <ContenuCredits t={t} assetBaseUrl={assetBaseUrl} surLien={() => undefined} />
      </div>
    </div>
  );
}
